const commonCss = {
    header: {
        zIndex: 1
    },
    content: {
        overflow: 'auto',
        zIndex: 0,
        position: 'fixed',
        left: '0px',
        right: '0px'
    },
    footer: {
        background: 'rgb(240, 242, 245)',
        zIndex: 1,
        position: 'fixed',
        bottom: '0px',
        width: '100%',
    }
}

export const config = {
    header: {
        props: {

        },
        style: {
            na: {...commonCss.header,
                height: '0px',
                display: 'none',
                zIndex: 0
            },
            xs: {...commonCss.header,
                height: '54px'
            },
            sm: {...commonCss.header,
                height: '74px'
            },
            md: {...commonCss.header,
                height: '94px'
            },
            lg: {...commonCss.header,
                height: '114px'
            }
        }
    },
    content: {
        props: {

        }
    },
    footer: {
        props: {

        },
        style: {
            na: {...commonCss.footer,
                height: '0px',
                display: 'none',
                zIndex: 0
            },
            xs: {...commonCss.footer,
                height: '42px'
            },
            sm: {...commonCss.footer,
                height: '62px'
            },
            md: {...commonCss.footer,
                height: '82px'
            },
            lg: {...commonCss.footer,
                height: '102px'
            }
        }
    }
}

export function getContentStyle(size) {
    return {...commonCss.content,
        top: (function(type, top) {
            switch(type) {
                case 'na': return Number(top) + 'px';
                default: return Number(top) + 'px';
            }
        })(size.header, config.header.style[size.header].height.substring(
            0, config.header.style[size.header].height.indexOf('p')
        )),
        bottom: (function(type, bottom) {
            switch(type) {
                case 'na': return Number(bottom) + 'px';
                case 'xs': return (Number(bottom) + 6) + 'px';
                default: return Number(bottom) + 'px';
            }
        })(size.footer, config.footer.style[size.footer].height.substring(
            0, config.footer.style[size.footer].height.indexOf('p')
        ))
    }
}

export function funcHook() {
    this.updateView = updateView.bind(this);
}

function updateView(v) {
    this.setState({...this.state, view: v});
}
